import { Tabs, Layout, } from 'antd';
import ProductListView from '../components/collectingcenter/ProductListView'
import CustomerListView from '../components/collectingcenter/CustomerListView';
import CarListView from '../components/collectingcenter/CarListView';
import { CarOutlined, GoldOutlined, UserOutlined } from '@ant-design/icons';
import { useWindowDimensionContext } from '../hooks/WindowDimensionProvider';
import URLTabs from '../components/common/URLTabs';

export default function CCSettingView() {
  const { lessThanOrEqual } = useWindowDimensionContext();
  const isOnMobile = lessThanOrEqual('md');

  return (
    <Layout>
      <URLTabs
        size='large'
        defaultActiveKey='#customer'
        items={[
          { key: '#customer', label: <span>{isOnMobile ? null : <UserOutlined/>} ลูกค้า</span>, children: <CustomerListView /> },
          { key: '#product', label: <span>{isOnMobile ? null : <GoldOutlined />} สินค้า</span>, children: <ProductListView /> },
          { key: '#vehicle', label: <span>{isOnMobile ? null : <CarOutlined />} ยานพาหนะ</span>, children: <CarListView /> },
        ]}
      />
    </Layout>

  )
}